export const FORM_FIELD_NAMES = {
  PRO_RATA_AMOUNT: 'proRataAmount',
  PRO_RATA_SHARES: 'proRataShares',
  PRO_RATA_CLOSING_AMOUNT: 'proRataClosingAmount',
  PRO_RATA_CLOSING_SHARES: 'proRataClosingShares',
  PRO_RATA_AMOUNT_INPUT_MODE: 'proRataAmountInputMode',
  PRO_RATA_SHARES_INPUT_MODE: 'proRataSharesInputMode',
  PRO_RATA_REAL_BUYBACK_VALUE: 'realBuybackAmount',

  MANUAL_AMOUNT: '.amount',
  MANUAL_SHARES: '.numberOfShares',
  MANUAL_CLOSING_AMOUNT: '.closingAmount',
  MANUAL_CLOSING_SHARES: '.closingNumberOfShares',
  MANUAL_AMOUNT_INPUT_MODE: '.amountInputMode',
  MANUAL_SHARES_INPUT_MODE: '.numberOfSharesInputMode',
  MANUAL_REAL_BUYBACK_VALUE: '.realBuybackAmount',
} as const;

// Helper function for manual fields
export const getManualFieldName = (ownershipIndex: number, suffix: string) =>
  `ownership[${ownershipIndex}]${suffix}`;
